// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WmEP","importantInfo":"styles_importantInfo__CZSRu"};